import DownloadPopup from "components/core/modal-components/DownloadPopup";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CF_URLS } from "services/api/endpoints";
import { selectAuth } from "store/slices";
import { ERROR_TYPES, downloadOptionPdf } from "utils/constants";
import {
  dataDogErrorLog,
  findErrorMessage,
  getUserName,
  handleRefId,
  printReport
} from "utils/helpers";

export default function DownloadReportModal({
  isVisible,
  setIsVisible,
  mainDistrictId,
  districtId,
  billCycleCode,
  billDate,
  setIsLoading,
  throwError,
  setThrowError,
  throwErrorMessage,
  setThrowErrorMessage,
  reportCFUrl,
  setReportCFUrl
}) {
  const { auth } = useSelector(selectAuth);
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(downloadOptionPdf);

  //handle download
  const handleDownload = async () => {
    const reqBody = JSON.stringify({
      main_district_id: mainDistrictId,
      district_id: districtId,
      billing_cycle_code: billCycleCode,
      billing_date: billDate,
      user_name: getUserName(auth?.user),
      report_format: selectedValue?.type?.toUpperCase()
    });
    try {
      setIsLoading(true);
      setThrowError(false);

      let reportResponse = await printReport(
        reqBody,
        `${CF_URLS.printReports.billing.errorLogReport}`
      );
      if (!reportResponse.success) {
        setThrowErrorMessage(reportResponse.error);
        setThrowError(true);
      }
    } catch (e) {
      const error = e.message || findErrorMessage(ERROR_TYPES.ISSUE);
      const { refId, message } = handleRefId(error);
      setThrowErrorMessage(message);
      setThrowError(true);
      dataDogErrorLog(
        message,
        CF_URLS.printReports.billing.errorLogReport,
        {
          ...reqBody,
          error: e
        },
        refId
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setThrowError(false);
    setIsVisible(false);
    setReportCFUrl("");
  };

  return (
    <DownloadPopup
      title={t("billingErrorLog.billingErrorLogReport")}
      showPrintModal={isVisible}
      cfUrl={reportCFUrl}
      onCancleClick={handleCancel}
      onDownloadClick={handleDownload}
      setSelectedValue={setSelectedValue}
      setThrowError={setThrowError}
      throwError={throwError}
      throwErrorMessage={throwErrorMessage}
    />
  );
}
